import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  protected endpoint: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider/configurations';
  }

  private cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, v]) => v !== null && v !== undefined,
      ),
    );
  }

  async getConfigurationsByCategoryId(categoryId: number) {
    try {
      const response: any = await firstValueFrom(
        this.apiService.get(
          `${this.endpoint}?category_id=${categoryId}`,
          {},
          true,
        ),
      );

      return response;
    } catch (error) {
      console.error(
        'ConfigurationService.getConfigurationsByCategoryId error:',
        error,
      );
      throw error;
    }
  }

  async saveProviderCategorySettings(payload: Record<string, any>) {
    try {
      const response: any = await firstValueFrom(
        this.apiService.post(`${this.endpoint}`, payload),
      );

      return response;
    } catch (error) {
      console.error(
        'ConfigurationService.saveProviderCategorySettings error:',
        error,
      );
      throw error;
    }
  }
}
